import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Calculator from './pages/Calculator';

function App() {
  return (
    <BrowserRouter>
    {/* Configure subpages */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tool" element={<Calculator />} />
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;